﻿import { Inject, Pipe, Injectable } from "@fiqas/angular-utils"
import { FIQAssist  } from "../app";
import { TranslationService } from "../services/TranslationService";
import { LocalizationData } from "../models/localization";

export class FirstCapitalFilter {

    @Pipe({
        module: FIQAssist,
        selector: 'firstcapital',
        pure: false
    })
    public static FirstCapitalFilter() {

        return (key: string): string => {
            return (key.substr(0, 1) ||'').toUpperCase() + (key.substr(1)||'').toLowerCase();
        };
    }
}
